document.addEventListener('DOMContentLoaded', () => {
  const slideshowContainer = document.querySelector('.main-slideshow');
  if (!slideshowContainer) {
    return;
  }

  // Wait for Flickity to initialize and then disable its autoplay
  const waitForFlickity = () => {
    const flickityInstance = slideshowContainer.flickity;
    if (flickityInstance) {
      flickityInstance.destroy();
      
      // After destroying, Flickity might leave inline styles. Reset them.
      const flickityViewport = slideshowContainer.querySelector('.flickity-viewport');
      if (flickityViewport) {
        flickityViewport.style.height = 'auto';
      }
      const flickitySlider = slideshowContainer.querySelector('.flickity-slider');
      if (flickitySlider) {
        flickitySlider.style.transform = 'none';
      }
      
      return true;
    }
    return false;
  };

  // Try immediately, then wait if needed
  if (!waitForFlickity()) {
    const observer = new MutationObserver(() => {
      if (waitForFlickity()) {
        observer.disconnect();
      }
    });
    observer.observe(slideshowContainer, { childList: true, subtree: true });
  }

  const slides = slideshowContainer.querySelectorAll('.slideshow__slide');
  
  if (slides.length === 0) {
    return;
  }

  // Create custom pagination dots
  const dotsContainer = document.querySelector('.custom-page-dots');
  if (!dotsContainer) {
    return;
  }

  dotsContainer.innerHTML = '';
  let currentSlide = 0;
  let autoplayInterval;

  // Create dots for each slide
  for (let i = 0; i < slides.length; i++) {
    const dot = document.createElement('div');
    dot.classList.add('custom-dot');
    if (i === 0) dot.classList.add('is-selected');
    dotsContainer.appendChild(dot);

    dot.addEventListener('click', () => {
      goToSlide(i);
    });
  }

  const dots = dotsContainer.querySelectorAll('.custom-dot');

  function goToSlide(index) {
    // Add fade transition
    slides.forEach((slide, i) => {
      slide.style.transition = 'opacity 0.5s ease-in-out';
      slide.style.opacity = '0';
      slide.setAttribute('aria-hidden', 'true');
      slide.classList.remove('is-selected');
    });

    // Show selected slide with fade
    slides[index].style.opacity = '1';
    slides[index].removeAttribute('aria-hidden');
    slides[index].classList.add('is-selected');

    // Update dots
    if (dots.length > 0) {
      dots.forEach(dot => dot.classList.remove('is-selected'));
      if (dots[index]) {
        dots[index].classList.add('is-selected');
      }
    }

    currentSlide = index;
  }

  function stopAutoplay() {
    if (autoplayInterval) {
      clearInterval(autoplayInterval);
      autoplayInterval = null;
    }
  }

  function startAutoplay() {
    // Stop any existing autoplay first
    stopAutoplay();
    
    // Use the custom autoplay interval attribute
    const autoplayIntervalMs = slideshowContainer.getAttribute('data-custom-autoplay-interval');
    
    if (autoplayIntervalMs && autoplayIntervalMs !== 'false') {
      autoplayInterval = setInterval(() => {
        const nextSlide = (currentSlide + 1) % slides.length;
        goToSlide(nextSlide);
      }, parseInt(autoplayIntervalMs));
    }
  }

  // --- Custom Drag/Swipe Functionality ---
  let isDragging = false;
  let startX = 0;
  const dragThreshold = 50; // Min pixels to swipe

  function dragStart(e) {
    if (e.target.closest('a, button')) return; // Ignore on links/buttons
    isDragging = true;
    startX = e.pageX || e.touches[0].pageX;
    slideshowContainer.style.cursor = 'grabbing';
    stopAutoplay();
    if (e.type === 'mousedown') {
      e.preventDefault();
    }
  }

  function dragMove(e) {
    if (!isDragging) return;
    // For visual feedback during drag if needed in future
  }

  function dragEnd(e) {
    if (!isDragging) return;
    isDragging = false;
    slideshowContainer.style.cursor = 'grab';

    const endX = e.pageX || e.changedTouches[0].pageX;
    const dragDistance = endX - startX;

    if (Math.abs(dragDistance) > dragThreshold) {
      if (dragDistance < 0) { // Swiped left
        const nextSlide = (currentSlide + 1) % slides.length;
        goToSlide(nextSlide);
      } else { // Swiped right
        const nextSlide = (currentSlide - 1 + slides.length) % slides.length;
        goToSlide(nextSlide);
      }
    }
    
    // Restart autoplay if mouse is not over the container
    if (!slideshowContainer.matches(':hover')) {
      startAutoplay();
    }
  }

  // Desktop and Mobile Drag Listeners
  slideshowContainer.addEventListener('mousedown', dragStart);
  document.addEventListener('mousemove', dragMove);
  document.addEventListener('mouseup', dragEnd);
  
  slideshowContainer.addEventListener('touchstart', dragStart, { passive: true });
  document.addEventListener('touchmove', dragMove, { passive: true });
  document.addEventListener('touchend', dragEnd);

  // Add hover pause functionality to both slideshow and dots
  slideshowContainer.addEventListener('mouseenter', stopAutoplay);
  slideshowContainer.addEventListener('mouseleave', startAutoplay);
  
  dotsContainer.addEventListener('mouseenter', stopAutoplay);
  dotsContainer.addEventListener('mouseleave', startAutoplay);

  // Start autoplay initially
  startAutoplay();
}); 